export const getMinMax = (...values: number[]): [number, number] => {
  const sorted = values.sort();
  return [sorted[0], sorted[sorted.length - 1]];
};
